function LeadCell({ data }) {
  const initials = data.avatar ? data.avatar.slice(0, 2) : data.title.slice(0, 2);
  return (
    <div className="lead">
      <div className="lead-avatar">{initials}</div>
      <div className="lead-copy">
        <div className="lead-title">{data.title}</div>
        {data.subtitle ? <div className="lead-subtitle">{data.subtitle}</div> : null}
      </div>
    </div>
  );
}

export default LeadCell;
